import { TableEmpresas } from "./Components/table/TableEmpresas";

export const PageEmpresa = () => {
  return <TableEmpresas />;
};
